import {
  dateFormat,
  formatDateAndTime,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { renderToStaticMarkup } from 'react-dom/server'
import QRCode from 'react-qr-code'
import React from 'react'

const generateQRCodeSVG = value => {
  const qrCodeElement = (
    <QRCode
      size={128}
      style={{ height: '75px', width: '75px' }}
      value={value}
      // viewBox={`0 0 128 128`}
    />
  )
  return renderToStaticMarkup(qrCodeElement)
}

export const ELetterServiceAR = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
}) => {
  const debtorDetails = {
    '[DebtorName]':
      previewDetail?.DebtorAccount?.CompanyName! ??
      previewDetail?.DebtorAccount?.DebtorName!,
    '[DebtorAddress]': `${previewDetail?.DebtorAccount?.Address?.address}<br />
          ${
            previewDetail?.DebtorAccount?.Address?.country == 'Singapore'
              ? `${previewDetail?.DebtorAccount?.Address?.country} ${previewDetail?.DebtorAccount?.Address?.postCode}`
              : `${previewDetail?.DebtorAccount?.Address?.postCode} ${previewDetail?.DebtorAccount?.Address?.city}, 
            ${previewDetail?.DebtorAccount?.Address?.state}, ${previewDetail?.DebtorAccount?.Address?.country}`
          }
           <br />`,
    '[DebtorCompanyRegNo]': previewDetail?.DebtorAccount?.CompanyRegNo! ?? '',
    '[DebtorSSTRegNo]': previewDetail?.DebtorAccount?.SSTNo! ?? '',
    '[DebtorGSTRegNo]': previewDetail?.DebtorAccount?.GSTNo! ?? '',
    '[DebtorBankAccName]': previewDetail?.DebtorAccount?.BankName! ?? '',
    '[DebtorBankAccNo]': previewDetail?.DebtorAccount?.BankAccountNo! ?? '',
    '[DebtorEmail]': previewDetail?.DebtorAccount?.Email! ?? '',
    '[DebtorPhoneNo]': previewDetail?.DebtorAccount?.OfficeNo! ?? '',
    '[DebtorMobileNo]': previewDetail?.DebtorAccount?.MobileNo! ?? '',
    '[DebtorTIN]': previewDetail?.DebtorAccount?.einvoice_TIN! ?? '',
    '[DebtorCreditTerm]': previewDetail?.DebtorAccount?.CreditTerm! ?? '',
    /////
    // Debtor Contact Parameters
    '[DebtorContactName]':
      previewDetail?.DebtorAccount?.DebtorContact[0]?.Name! ?? '',
    '[DebtorContactNo]':
      previewDetail?.DebtorAccount?.DebtorContact[0]?.ContactNo! ?? '',
    '[DebtorContactEmail]':
      previewDetail?.DebtorAccount?.DebtorContact[0]?.Email! ?? '',
    /////
    // '[TaxSSTRegNo]': previewDetail?.SSTRegNo! ?? '',
    // '[TaxGSTRegNo]': previewDetail?.GSTRegNo! ?? '',
    // Document Parameters
    '[DocumentNo]': previewDetail?.DocNo! ?? '',
    '[DocumentDate]': dateFormat(previewDetail?.DocDate!) ?? '',
    '[ReferenceNo]': previewDetail?.RefNo! ?? '',
    ////
    // E-Invoice Parameters
    '[QRCode]':
      previewDetail?.is_einvoice && previewDetail?.einvoice_qr_url
        ? generateQRCodeSVG(previewDetail?.einvoice_qr_url)
        : '',
    '[EInvoiceValidatedDate]': previewDetail?.einvoice_validation_date
      ? formatDateAndTime(previewDetail?.einvoice_validation_date)
      : '',
    '[EInvoiceSentDate]': previewDetail?.einvoice_sent_date
      ? formatDateAndTime(previewDetail?.einvoice_sent_date)
      : '',
    '[EInvoiceStatus]': previewDetail?.einvoice_status ?? '',
    '[UIN]': previewDetail?.einvoice_irbm_uniqueID ?? '',
  }

  switch (docType) {
    case 'official-receipt':
      Object.assign(paramVal, debtorDetails, {
        '[Remark]': previewDetail?.Remark! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[BankAccName]': previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[BankCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[BankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[DocAmt]': amtStr(previewDetail?.DocAmt) ?? '',
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
        '[TotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
      })
      break
    case 'refund':
      Object.assign(paramVal, debtorDetails, {
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[BankAccName]': previewDetail?.BankAccount?.BankProfile?.Name! ?? '',
        '[BankCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[BankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
        '[TotalAmt]': amtStr(previewDetail?.DocAmt) ?? '',
      })
      break
    case 'invoice':
      return Object.assign(paramVal, debtorDetails, {
        '[DueDate]': dateFormat(previewDetail?.DueDate!) ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',

        items: previewDetail?.ARInvoiceItem?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemRemark]': el?.Remark,
            '[TaxRate]': amtStr(el?.TaxRate),
            '[BaseAmt]': amtStr(el?.Amount),
            '[TaxAmt]': amtStr(el?.TaxAmt),
            '[TotalAmt]': amtStr(el?.DocAmt),
          }
        }),
        '[SumBaseAmt]': amtStr(
          allpreviewDetail?.ARInvoiceItem?.reduce(
            (a, b) => a + Number(b?.Amount),
            0
          )
        ),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.ARInvoiceItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0
          )
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.ARInvoiceItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0
          )
        ),
      })
      break
    case 'credit-note':
      return Object.assign(paramVal, debtorDetails, {
        '[Description]': previewDetail?.Description! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        // Item listing
        items: previewDetail?.ARCreditNoteItem?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemRemark]': el?.Remark,
            '[TaxRate]': amtStr(el?.TaxRate),
            '[TaxAmt]': amtStr(el?.TaxAmt) ?? '',
            '[BaseAmt]': amtStr(el?.Amount) ?? '',
            '[TotalAmt]': amtStr(el?.DocAmt),
          }
        }),
        allocItems: previewDetail?.Allocation?.map((el, i) => {
          return {
            '[AllocIndex]': i + 1,
            '[AllocDocDate]': !!el?.DebitDocDate
              ? dateFormat(el?.DebitDocDate!)
              : '',
            '[AllocDocNo]': !!el?.DebitDocNo ? el?.DebitDocNo! : '',
            '[AllocDesc]': !!el?.Description ? el?.Description! : '',
            '[AllocAmt]': !!el?.AllocationAmt ? amtStr(el?.AllocationAmt!) : '',
          }
        }),
        '[SumBaseAmt]':
          amtStr(
            allpreviewDetail?.ARCreditNoteItem?.reduce(
              (a, b) => a + Number(b?.Amount),
              0
            ).toFixed(2)
          ) ?? '',
        '[SumTaxAmt]':
          amtStr(
            allpreviewDetail?.ARCreditNoteItem?.reduce(
              (a, b) => a + Number(b?.TaxAmt),
              0
            ).toFixed(2)
          ) ?? '',
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.ARCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0
          )
        ),
      })
      break
    case 'debit-note':
      return Object.assign(paramVal, debtorDetails, {
        '[Description]': previewDetail?.Description! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[DueDate]': dateFormat(previewDetail?.DueDate!) ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        items: previewDetail?.ARDebitNoteItem?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemRemark]': el?.Remark,
            '[TaxRate]':
              el?.TaxScheme?.TaxSchemeDetail?.length === 1
                ? el?.TaxScheme?.TaxSchemeDetail[0]?.taxRate + '%'
                : '',
            '[TaxAmt]': amtStr(el?.TaxAmt) ?? '',
            '[BaseAmt]': amtStr(el?.Amount) ?? '',
            '[TotalAmt]': amtStr(el?.DocAmt),
          }
        }),
        '[SumBaseAmt]':
          amtStr(
            allpreviewDetail?.ARDebitNoteItem?.reduce(
              (a, b) => a + Number(b?.Amount),
              0
            ).toFixed(2)
          ) ?? '',
        '[SumTaxAmt]':
          amtStr(
            allpreviewDetail?.ARDebitNoteItem?.reduce(
              (a, b) => a + Number(b?.TaxAmt),
              0
            ).toFixed(2)
          ) ?? '',
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt),
      })
      break
  }
}
